import { render, staticRenderFns } from "./OpticalModule.vue?vue&type=template&id=7976b207&scoped=true&"
import script from "./OpticalModule.vue?vue&type=script&lang=js&"
export * from "./OpticalModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7976b207",
  null
  
)

export default component.exports